export default {
    edit: 'Rediger',
    location: 'Lokation + vilkår',
    filter: 'Filter',
};
